export default {
  dbi_compare_clear_all: 'Clear All',
  dbi_compare_last_1_day: 'Last Day',
  dbi_compare_last_1_week: 'Last Week',
  dbi_compare_last_1_month: 'Last Month',
  dbi_compare_last_3_month: 'Last 3 Month',
  dbi_compare_last_6_month: 'Last 6 Month',
  dbi_compare_last_12_month: 'Last 12 Month',
  dbi_compare_pc_console_title: 'PC & Console Games',
  dbi_compare_heat_map: 'Heat Map',
  dbi_compare_show_top_3_countries: 'Show Top 3 Countries',
  dbi_compare_show_top_countries: 'Show Top {num} Countries',
  dbi_compare_label_device: 'Device',
  dbi_compare_aligned_by_launch_time: 'Aligned by Launch Time',
  dbi_compare_add_game_to_compare: 'Add Games to Compare',
  dbi_compare_similar_games: 'Similar games',
  dbi_compare_selected: 'Selected',
  dbi_compare_not_select_game_yet: 'You haven’t selected the game yet,',
  dbi_compare_please_search_game: 'please search in the search box.',
  dbi_compare_please_search_game_only: 'Please search in the search box.',
  dbi_compare_please_search_game_above: 'Please search for a game in the search box above.',
  dbi_compare_select_games_limit_tips: 'Up to {max} games can be selected for comparison',
  dbi_compare_add_games: 'Add Games',
  dbi_compare_clear_all_confirm_tips: 'Are you sure to clear all the games?',
  dbi_compare_pc_console_download_tips:
    'Separate by time：will return the data separeted by daily/weekly/monthly granularity.Aggregated method:will return the data with current filter.',
  dbi_compare_no_pc_version_tips: 'No PC version',
  dbi_compare_no_console_version_tips: 'No Console version',
  dbi_compare_us_data_only_tips: 'Only data from ths U.S.market',

  dbi_compare_mobile_current_store_rank: 'Current Store Rank',
  dbi_compare_mobile_key_metric_tips:
    "Sensor Tower and data.ai do not apply the same algorithm model and invest different cost resources in each market (For example, Sensor Tower's investment in the Southeast Asian market will be higher compared to annie, while data.ai's resources for country regions are tilted to the first tier is the United States, China and Japan, the second tier is France, Germany, Italy, Spain, UK, Mexico, Brazil, India, Russia, Canada, South Korea, Australia, Taiwan,China, Singapore, and the rest of the countries are the third tier), so there are differences in the data.",
  dbi_compare_mobile_current_rank: 'Current Rank',
  dbi_compare_mobile_countries_counts: 'Countries Counts',
  dbi_compare_mobile_total_regions: 'Total Regions',
  dbi_compare_mobile_number_of_countries_rank: 'Number of Countries Rank {rankRangeText}',
  dbi_compare_mobile_wow: 'WoW {num}',
  dbi_compare_mobile_no: 'No.{num}',

  dbi_compare_pcconsole_same_start_date: 'Same Start Date(Incl.Align To Release)',
  dbi_compare_pcconsole_different_start_date: 'Different Start Date(For Event Analysis)',
  dbi_compare_pcconsole_games_beta_title: 'Multi-dimensional Comparison - PC&Console Games',
  dbi_compare_pcconsole_game_selection_empty: `You haven't selected the game yet. Please search in the search box or click the shortcut `,
  dbi_compare_pcconsole_game_filter_time_tips: `Day/Week/Month granularity correspond to different metrics. For example, click week granularity to select GSD metrics.`,
  dbi_compare_pcconsole_game_filter_platform_tips: `When ‘Align to Release’ is switched on, the corresponding release time will change when switching platforms. When multiple platforms are selected, the corresponding release time will be the earliest one among multiple platforms.`,
  dbi_studio_competitor_game_selection_empty: `Please search in the search box or click the shortcut`,

  'POE-like': `POE-like`,
  'Tarkov-like': `Tarkov-like`,
  'Dying Light 2-related': `Dying Light 2-related`,
  'Dune-related': 'Dune-related',

  dbi_compare_metric_pcu: 'PCU',
  dbi_compare_metric_acu: 'CCU',
  dbi_compare_metric_pcu_tips: 'Peak Concurrent Users',
  dbi_compare_metric_acu_tips: 'Concurrent Users',
};
